/**
 * @file store getters
 * @author wangzhongpeng
 */

export default {
  columnTreeList (state) {
    return state.columnTreeList
  },
  footerList (state) {
    return state.footerList
  },
  user (state) {
    return state.user
  },
  isLogin (state) {
    return !!state.user
  },
  activeIndex: state => {
    return state.activeIndex
  },
  columnItem: state => {
    return state.columnItem
  },
  columnItemParent: state => {
    return state.columnItemParent
  },
  activeChildrenIndex: state => {
    return state.activeChildrenIndex
  },
  contentId: state => {
    return state.contentId
  },
  token (state) {
    return state.token || ''
  },
  specialInfo (state) {
    return state.specialInfo
  }

}



// WEBPACK FOOTER //
// ./src/store/getters.js